<template>
    <b-modal
        id="modal-quick-navigation"
        :visible="value"
        title="Hızlı Navigasyon Ekle"
        size="md"
        no-close-on-backdrop
        @hidden="$emit('input', false)"
    >
        <b-form @submit.prevent="save">
            <b-form-group label="Navigasyon Anahtarı *">
                <b-form-input
                    v-model="form.navigationKey"
                    placeholder="home, about, contact"
                />
            </b-form-group>

            <b-form-group label="Navigasyon Tipi">
                <v-select
                    v-model="form.navigationType"
                    :options="navTypes"
                    :reduce="type => type.value"
                    label="label"
                />
            </b-form-group>

            <b-form-group label="Manuel URL">
                <b-form-input
                    v-model="form.customUrl"
                    placeholder="/sayfa-yolu"
                />
            </b-form-group>

            <b-tabs pills>
                <b-tab
                    v-for="lang in languages"
                    :key="lang.LanguageCode"
                    :title="lang.LanguageName"
                >
                    <b-form-group label="Başlık" class="mt-2">
                        <b-form-input
                            v-model="getTranslation(lang.LanguageCode).Title"
                            placeholder="Menü Başlığı"
                        />
                    </b-form-group>
                </b-tab>
            </b-tabs>

            <b-form-checkbox v-model="form.isActive" switch>
                Aktif
            </b-form-checkbox>
        </b-form>

        <template #modal-footer>
            <b-button variant="secondary" @click="$emit('input', false)">
                İptal
            </b-button>
            <b-button variant="primary" :disabled="loading" @click="save">
                <b-spinner v-if="loading" small class="mr-50" />
                Kaydet
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormCheckbox, BButton, BTabs, BTab, BSpinner } from 'bootstrap-vue';
import vSelect from 'vue-select';
import WebsiteApi from '@/api/website';

export default {
    name: 'QuickNavigationModal',
    components: {
        BModal, BForm, BFormGroup, BFormInput, BFormCheckbox,
        BButton, BTabs, BTab, BSpinner, vSelect
    },
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            languages: [],
            navTypes: [
                { label: 'Ana Menü', value: 'main' },
                { label: 'Footer', value: 'footer' },
                { label: 'Yan Menü', value: 'sidebar' }
            ],
            form: {
                navigationKey: '',
                navigationType: 'main',
                customUrl: '',
                isActive: true,
                openInNewTab: false,
                showCta: false,
                sortOrder: 0,
                translations: []
            }
        };
    },
    watch: {
        value(val) {
            if (val) {
                this.loadLanguages();
            }
        }
    },
    methods: {
        async loadLanguages() {
            try {
                const response = await WebsiteApi.Language.GetAll();
                if (response.data.Success) {
                    this.languages = response.data.Data;
                    this.initializeTranslations();
                }
            } catch (error) {
                console.error('Diller yüklenemedi:', error);
            }
        },

        initializeTranslations() {
            this.form.translations = this.languages.map(lang => ({
                LanguageCode: lang.LanguageCode,
                Title: '',
                Description: ''
            }));
        },

        getTranslation(languageCode) {
            let translation = this.form.translations.find(t => t.LanguageCode === languageCode);
            if (!translation) {
                translation = {
                    LanguageCode: languageCode,
                    Title: '',
                    Description: ''
                };
                this.form.translations.push(translation);
            }
            return translation;
        },

        async save() {
            if (!this.form.navigationKey) {
                this.$toast.warning('Navigasyon anahtarı zorunludur!');
                return;
            }

            this.loading = true;
            try {
                const payload = {
                    NavigationKey: this.form.navigationKey,
                    NavigationType: this.form.navigationType,
                    CustomUrl: this.form.customUrl,
                    IsActive: this.form.isActive,
                    OpenInNewTab: this.form.openInNewTab,
                    ShowCta: this.form.showCta,
                    SortOrder: this.form.sortOrder,
                    Translations: this.form.translations
                };

                const response = await WebsiteApi.Navigation.Create(payload);
                this.$result(response);

                if (response.data.Success) {
                    this.$emit('saved');
                    this.$emit('input', false);
                    this.resetForm();
                }
            } catch (error) {
                this.$result(null, error);
            } finally {
                this.loading = false;
            }
        },

        resetForm() {
            this.form = {
                navigationKey: '',
                navigationType: 'main',
                customUrl: '',
                isActive: true,
                openInNewTab: false,
                showCta: false,
                sortOrder: 0,
                translations: []
            };
        }
    }
};
</script>